/**
 * FacilitatorStatusService
 * Service for managing facilitator statuses
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for facilitator status CRUD operations
 */
export class FacilitatorStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? FacilitatorStatusService.DEFAULT_SERVICE_PATH,
            basePath: FacilitatorStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
FacilitatorStatusService.DEFAULT_SERVICE_PATH = 'ac-courses';
FacilitatorStatusService.BASE_PATH = 'api/facilitator-statuses';
//# sourceMappingURL=FacilitatorStatusService.js.map